/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ProductQuery } from '@gql/ProductQuery'
import { WatchQueryFetchPolicy } from '@apollo/client'

export function useProductQuery(
  inputIn: () => None | { slug?: string | None },
  pricing: ProductPricingType,
  on?: (i: gen.ProductQuery['catalogProduct']) => void,
  fetchPolicy?: WatchQueryFetchPolicy
) {
  // const b2b = useB2B()
  const ui = useApolloWrap2<gen.ProductQuery, gen.ProductQueryVariables>(ProductQuery)({
    fetchPolicy,
    vars() {
      const slug = inputIn()?.slug
      return slug ? { input: { slug } } : undefined
    },
    ui: (i) => i?.catalogProduct,
    on: (i) => on?.(i?.ui),
  })
  const { toDoc } = useCatalogPrivate(() => ui.ui.value, pricing, fetchPolicy)
  return {
    ui: computed(() => toDoc(ui.ui.value)),
    loading: toRef(() => ui.loading.value),
  }
}
